import LocalStore from '@/providers/local-store';

const store = new LocalStore( 'upi-pp-event-registrants' );
store.setDefaultValue( [] );
export default store;
